import { render } from "./PaiceConfirm.vue?vue&type=template&id=fc67f99a&scoped=true"
import script from "./PaiceConfirm.vue?vue&type=script&lang=js"
export * from "./PaiceConfirm.vue?vue&type=script&lang=js"

import "./PaiceConfirm.vue?vue&type=style&index=0&id=fc67f99a&scoped=true&lang=css"
import "./PaiceConfirm.vue?vue&type=style&index=1&id=fc67f99a&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc67f99a"]])

export default __exports__